
export default {
    menuList: [],
    totalRecords: 0,
}